const abortError=()=>new DOMException('Preview cancelled','AbortError')
export function waitForPreview(ms,signal){return new Promise((resolve,reject)=>{if(signal?.aborted){reject(abortError());return}let timer;const cancel=()=>{clearTimeout(timer);reject(abortError())};timer=setTimeout(()=>{signal?.removeEventListener('abort',cancel);resolve()},ms);signal?.addEventListener('abort',cancel,{once:true})})}
// Only the exact derivative admission response is retryable. No original fallback,
// auth retry, write retry, or unbounded timer. The shared queue slot stays occupied.
export async function readArtworkPreviewWithRetry(read,{signal,wait=waitForPreview,random=Math.random}={}){
 for(let attempt=0;attempt<4;attempt++){
  if(signal?.aborted)throw abortError()
  try{return await read()}catch(error){
   if(error.status!==429||error.body?.error!=='artwork_preview_busy'||!Number.isInteger(error.body.retryAfterMs)||error.body.retryAfterMs<1000||error.body.retryAfterMs>5000||attempt===3)throw error
   const jitter=Math.floor(Math.max(0,Math.min(1,random()))*250),delay=Math.min(5000,error.body.retryAfterMs*2**attempt)+jitter
   await wait(delay,signal)
  }
 }
}
